export default __webpack_public_path__ + "static/media/9.9c8e9193.jpg";